import React from "react";

const ABOUT_IMG =
  "https://images.pexels.com/photos/6285157/pexels-photo-6285157.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-28 md:py-40 bg-[var(--bg-secondary)]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-10 md:gap-16 items-center">
        <div className="md:col-span-5 reveal">
          <div className="zoom-img aspect-[4/5] border border-white/10">
            <img
              src={ABOUT_IMG}
              alt="Reviewing blueprints at the studio"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        </div>

        <div className="md:col-span-7 reveal reveal-delay-1">
          <div className="flex items-center gap-4 mb-6">
            <span className="hairline w-10" />
            <span className="eyebrow">About The Studio</span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl leading-[1.08] tracking-tight text-[var(--text-primary)] mb-8">
            A new studio. A lighthouse for the people who build with us.
          </h2>
          <p className="text-[var(--text-secondary)] text-lg leading-relaxed mb-6">
            Creative Property Development is a general contracting and
            property development firm founded on a simple idea — that
            construction should feel like collaboration, not combat. We take
            on a small, deliberate number of projects every year so every
            client gets the attention, craft, and honesty they deserve.
          </p>
          <p className="text-[var(--text-secondary)] text-lg leading-relaxed mb-6">
            Headquartered near Newark, we serve clients across all of New
            Jersey — with deep roots along the Jersey Shore and throughout
            Monmouth County, from Rumson and Holmdel to Colts Neck, Red Bank,
            and Spring Lake.
          </p>
          <blockquote className="font-display italic text-2xl md:text-3xl leading-snug text-[var(--accent)] border-l border-[var(--accent)] pl-6 my-10">
            “Guiding your vision from foundation to finish.”
          </blockquote>

          <div className="grid grid-cols-3 gap-6 md:gap-10 pt-6 border-t border-white/10">
            <Pill label="Transparent" sub="Budgets" />
            <Pill label="Weekly" sub="Site Updates" />
            <Pill label="Warrantied" sub="Delivery" />
          </div>
        </div>
      </div>
    </section>
  );
}

function Pill({ label, sub }) {
  return (
    <div>
      <div className="font-display text-xl md:text-2xl text-[var(--text-primary)]">
        {label}
      </div>
      <div className="font-body text-[10px] uppercase tracking-[0.3em] text-[var(--text-secondary)] mt-1">
        {sub}
      </div>
    </div>
  );
}
